import { CoreDataSecurityMonitorsAllName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsAllSlice } from './get';
import { PatchDataSecurityMonitorByIdRequest } from '@api/data-security';

export const updateCoreDataSecurityMonitorsAllSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreDataSecurityMonitorsAllName,
	state: getCoreDataSecurityMonitorsAllSlice.asyncState,
	target: (request: PatchDataSecurityMonitorByIdRequest) => (monitor) => monitor.id === request.id,
	update: (request: PatchDataSecurityMonitorByIdRequest) => (monitor) => ({
		...monitor,
		...request
	}) as typeof monitor
});
